import styled from 'styled-components';
import { Container } from 'styles';

export const LatestStatementWrapper = styled(Container)<StyleProps>`
  background: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
  text-align: center;
`;
